import Idioma from '../Idioma'
export default new Idioma({
  idioma:'es',
  pasos: {
    uno: 'Fes reserva',
    dos: 'Serveis que desitges',
    tres: 'Identificació',
    cuatro: 'Resum i pagament'
  },
  resumen:{
    para: 'per',
    personas: 'persona(es)',
    entrada: 'Entrada:',
    salida: 'Sortida:'
  },
  datosReserva:{
    selecciona: 'Selecciona tipus d\'allotjament',
    sistema: 'Sistema de reserves',
    antes: 'Informa\'t abans de reservar',
    textoAntes:[
      'Llegeix atentament totes les indicacions que trobaràs als diferents passos per poder fer la teva reserva el més satisfactòriament possible.',
      'En acabar el procés de reserva en línia rebràs un correu electrònic amb el codi i dades de la teva reserva. No ho perdis, ho necessitaràs per realitzar qualsevol tipus de modificació de la mateixa.',
      'Per anul·lar una reserva, cal que us poseu en contacte amb l\'establiment.',
      'Als quadres d\'observacions podràs indicar-nos qualsevol cosa que creguis necessària. Com més informació ens proporcioneu millor podrem atendre la vostra sol·licitud.',
      'Recorda que (sempre que hi hagi disponibilitat de places), disposes d\'un temps limitat per fer la reserva (el sistema bloqueja les places que sol·licites fins que fas el pagament de la bestreta corresponent). Si superes aquest temps el sistema anul·larà la teva sol·licitud i hauràs de tornar a iniciar el procés.'
    ],
    fechas:'Informació sobre les dates',
    textoFechas:[
      'Si desitges reservar el mateix dia o un dia més tard, no podràs fer la reserva en línia, hauràs de contactar directament amb l\'establiment.',
      'El nombre màxim de nits a reservar per internet és de 4 nits.\n'
    ],
    numeroPlazas: 'Nombre de places',
    plazasSelect:'Selecciona el # de persones',
    plazas:'Informació sobre les places',
    textoPlazas:[
      'El sistema de reserves per Internet té a la vostra disposició un nombre limitat de places de cada establiment. Si no pots reservar en línia contacta per telèfon.',
      'A la major part dels establiments d\'aquest motor de reserves, les places s\'organitzen en habitació compartida, si voleu un altre tipus d\'allotjament poseu-vos en contacte directament amb l\'establiment.'
    ],
    multiple:{
      cabecera:'Sistema de reserves múltiples:',
      texto:'Consulta disponibilitat al primer refugi i fes ús d\'aquesta eina per planificar tota la ruta.'
    },
    otro:'Vols afegir un altre refugi a la teva reserva?',
    seleccionaOtro:'Selecciona un altre establiment',
    otroBtn: 'Afegir a la reserva',
    errorReserva:'Reviseu les dates seleccionades o el nombre de persones.',
    continuar:'Continuar',
    errors:{
      cerrado:'No es pot seleccionar un dia tancat',
      completo: 'No es pot seleccionar com a dia dentrada un dia complet',
      online: 'Per reservar aquest dia consulteu directament amb l\'establiment',
      salida: 'No es pot seleccionar com a dia de sortida un dia tancat',
      rango: 'No compleix els requisits per fer la reserva',
      invalidDate: 'No es pot seleccionar com la data d´entrada avui o demá',
      personas: {
        principio: 'No es poden reservar ',
        final: ' places per al dia:'
      }
    }
  },
  datosServicios:{
    selecciona:'Selecciona els serveis',
    fecha: 'Data',
    desayuno: 'Esmorzar',
    comida: 'Menjar',
    picnic: 'Picnic',
    cena: 'Sopar',
    pernocta: 'Pernocta',
    observaciones: 'Afegeix en aquest apartat qualsevol comentari que consideris necessari en relació amb el servei que estàs reservant',
    btnReserva: 'Tramitar la reserva',
    btnCancelar: 'Cancel·lar la reserva',
    cerrarCancelar: 'Continuar amb la reserva',
    confirmarCancelar: 'Cancel·lar la reserva',
    textoCancelar: 'Voleu cancel·lar aquesta reserva?',
    infoCabecera:'Informació sobre els serveis',
    info:'Si el dia d\'entrada calculeu que arribareu més tard de les 19 hores, poseu-vos en contacte amb l\'establiment per saber si podeu reservar el sopar d\'aquell dia.',
    otrosServicios:{
      otros:'Altres serveis'
    }
  },
  datosResumen:{
    resumen: 'Resum de la teva reserva',
    entrada: 'Data d\'entrada:',
    salida: 'Data de sortida:',
    distintos: 'Serveis diferents de la pernocta',
    dia: 'Dia',
    totalAdelanto: 'Total avenç a abonar per refugi:',
    textoAdelanto:[
      'Aquest import és únicament en concepte de bestreta de reserva. Per conèixer el total de l\'import de la reserva cal consultar l\'apartat Preus de l\'establiment. Cal recordar que els descomptes a federats ho són per a aquells federats FEDME i pertanyents al conveni Europeu de Reciprocitat de Refugis.'
    ],
    total: 'Total avançament de la reserva:',
    tiempoRestante: 'Temps restant per completar la reserva:',
    tiempoFin:'S\'ha acabat el temps per fer la reserva.',
    pago: 'Identificar-se i pagar',
    plazas:'Nombre de places',
    noches:'Nombre de nits',
    AceptarBtn:'Acceptar i pagar',
    CancelarBtn:'Cancel·lar la reserva',
    cerrarCancelar: 'Continuar amb la reserva',
    confirmarCancelar: 'Cancel·lar la reserva',
    textoCancelar: 'Voleu cancel·lar aquesta reserva?'
  },
  datosPersonales:{
    intro: 'Si ja sou un usuari registrat de alberguesyrefugios.com',
    mensaje: ['Tindreu accés ràpid i sense esforç', 'a la vostra informació'],
    opcion: 'També podeu',
    continuar: 'continuar sense registrar -vos',
    nombre:'Nom',
    apellidos:'Cognoms',
    dni:'DNI/NIE',
    fnac:'Data de naixement',
    direccion:'Direcció',
    cp:'Codi Postal',
    poblacion:'Població',
    provincia:'Província',
    pais:'País',
    tfno:'Telèfon',
    club:'Club al que pertanys',
    correoe:'Correu electrònic',
    confirmar:'Confirmar correu electrònic',
    registro:'Voleu donar-vos d\'alta a la nostra plataforma de reserves amb aquestes dades?',
    observaciones: '  Afegeix en aquest apartat qualsevol comentari que consideris necessari en relació amb la reserva que estàs realitzant.',
    crearUsuario: 'Voleu crear un usuari amb aquestes dades?',
    tarjetainfo: '  He llegit la informació sobre la Targeta Federativa als Refugis de la FAM',
    infoTarjetaCabecera:'Informació sobre les targetes federatives',
    infoTarjeta:'Als refugis i albergs gestionats per la FAM, únicament s\'admet com a document acreditatiu d\'estar Federat (i per tant tenir descompte en els preus), la presentació de la targeta federativa FEDME (o estrangeres amb Conveni Europeu de Reciprocitat) de l\'any en curs . En cap cas no s\'admet cap tipus de certificats de tramitació de targetes, siguin expedits per Clubs o Federacions.',
    informacion:'Vull rebre informació i notícies sobre refugis i albergs',
    conformidad: {
      acepto: 'Accepto les',
      y:'i la'
    },
    condiciones:'condicions de reserva',
    proteccion: {
      acepto: 'Accepto le ',
      datos:'llei de protecció de dades'
    },
    AceptarBtn:'Aceptar i pagar',
    CancelarBtn:'Cancel·lar la reserva',
    cerrarCancelar: 'Continuar amb la reserva',
    confirmarCancelar: 'Cancel·lar la reserva',
    textoCancelar: 'Voleu cancel·lar aquesta reserva?',
    legal:{
      condiciones:{
        titulo:'CONDICIONS SOBRE LA RESERVA ON-LINE',
        generales: {
          titulo: 'Condicions generals',
          texto:[
            'La realització d\'una reserva porta a l\'acceptació de les normes de funcionament i els horaris de l\'establiment sobre el qual es faci.',
            'Els establiments que apareixen en aquesta pàgina són majoritàriament albergs i refugis de muntanya. En aquest tipus d\'establiments, i excepte excepcions concretes, l\'allotjament és en habitació múltiple compartida, i en molts casos és necessari l\'ús de',
            'A molts dels establiments els menús que se serveixen són tancats, i no hi ha la possibilitat d\'escollir entre diversos plats o una carta.',
            'Cal haver consultat l\'apartat "Com arribar" abans de fer una reserva, alguns dels refugis són d\'alçada i només s\'hi pot arribar caminant.',
            'Per anul·lar o modificar una reserva us haureu de posar en contacte amb l\'establiment.'
          ]
        },
        anticipo: {
          titulo: 'Bestreta de reserva',
          inicio: [
            'Per fer una reserva en línia és necessari pagar una bestreta de la mateixa. La quantia del dit import està en funció dels serveis que es reservin.',
            'Les condicions de devolució del mateix són les següents:'
          ],
          lista:[
            'Si les reserves s\'anul·len abans de 6 dies de la data de la reserva, es tornarà el 100% de la bestreta cobrada menys els costos de gestió de la devolució i del motor de reserves si s\'originessin.',
            'Si s\'anul·len en els darrers 5 dies de la data de la reserva, es cobrarà el 100% del total de la bestreta.',
            'Les despeses de devolució són 1€ més 0,25€ per persona i pernocta fins a un màxim de 5€.'
          ],
          fin:[
            'En cas de "força major" es tornarà el 100% de la bestreta ingressada. Aquest concepte de "força major" l\'hauria de considerar el gestor de l\'establiment, decidint si un cas d\'anul·lació de reserva és o no de "força major", i si la part que reserva discrepa amb la decisió del guarda, es pot remetre llavors a la entitat gestora.',
            'Als establiments de la F.A.M. hi ha uns horaris límit d\'arribada per disposar de la plaça reservada. Si no es compleixen aquests horaris, la plaça quedarà lliure per als usuaris que la demanin. Consulteu les condicions del reglament per a cada refugi.'
          ]
        }
      }
    },
    avisoLegal:{
      tituloGeneral:'Avís legal',
      info:{
        titulo: 'Informació legal',
        texto:[
          'En compliment de l\'article 10 de la Llei 34/2002, d\'11 de juliol, de serveis de la societat de la informació i de comerç electrònic (LSSICE) presentem la informació següent:',
          '',
          'Raó Social: Federació Aragonesa de Muntanyisme',
          'Adreça: C/. Albareda 7, 4t 4a, 50004. Saragossa',
          'C.I.F.: V50120211',
          'Telèfon: 976227971',
          'E-mail: fam@fam.es',
          'Dades de la inscripció al Registre de Federacions: 05/3',
          '',
          'Raó Social: PRAMES S.A.',
          'Adreça: Camí dels Molins, 32. 50015. Saragossa.',
          'C.I.F: A50223031',
          'Telèfon: 976106170',
          'E-mail: lopd@prames.com',
          'Dades de la Inscripció al Registre Mercantil: 10.086 Foli: 185 Tom: 841',
        ]
      },
      proteccion:{
        titulo: 'Protecció de dades',
        texto:[
          '1. Completant el formulari de registre o de contacte, enviant un correu electrònic o trucant per telèfon, les vostres dades personals passaran a ser responsabilitat de l\'empresa les dades de la qual es relacionen a l\'apartat 1. Informació Legal.',
          '2. Aquestes dades s\'utilitzen per respondre a la seva sol·licitud o consulta el més aviat possible perquè vostè ens les proporciona informada i lliurement amb aquesta finalitat',
          'També ens comunicarem comercialment per mitjans electrònics amb els nostres clients en base al nostre interès legítim d\'oferir-los productes i serveis similars als que inicialment ens van contractar.',
          'Per a altres tractaments o finalitats relacionades amb la prestació dels nostres serveis o el desenvolupament de la nostra activitat, podeu obtenir més informació a la Política de Privadesa de PRAMES, S.A. o sol·licitar-los a la nostra adreça de contacte.',
          '3. Les dades personals recollides a la nostra pàgina web són tractades complint amb les exigències del Reglament (UE) 2016/679 del Parlament Europeu i del Consell, de 27 d\'abril de 2016, relatiu a la protecció de les persones físiques pel que fa al tractament de dades personals ia la lliure circulació daquestes dades.',
          '4. Un cop les dades no siguin necessàries per als fins amb què van ser recollides, es conservaran a disposició de les administracions públiques competents durant els terminis legals de conservació, és a dir mentre una llei ens pugui exigir que les presentem. Expirats aquests terminis es mantindran bloquejats fins que sigui possible la posterior destrucció o supressió.',
          '5. Podeu exercir els drets d\'accés, rectificació, supressió, oposició, limitació i portabilitat sobre les dades de caràcter personal presentant una còpia d\'un document identificatiu a: fam@fam.es',
          '6. Podeu revocar el consentiment prestat per a l\'enviament de comunicacions electròniques en el moment de fer la reserva, a l\'adreça anteriorment esmentada.',
          '7. Podeu trobar més informació sobre els vostres drets o presentar una reclamació davant l\'autoritat de control competent a l\'Agència Espanyola de Protecció de Dades http://www.agpd.es - C/ Jorge Juan, 6. 28001 – Madrid (901 100 099-912 663 517).'
        ]
      },
      limitacion:{
        titulo: 'Limitació de Responsabilitats',
        texto: [
          '1. La Federació Aragonesa de Muntanyisme proporciona el lloc web corporatiu com a mitjà de donar a conèixer les seves activitats i serveis i permetre el contacte amb els federats. La informació de la pàgina web es presenta de manera merament orientativa o divulgativa i en cap moment serà considerada vinculant.',
          '2. L\'entitat no es responsabilitza sobre els possibles danys informàtics que l\'usuari pugui patir mentre visita la nostra.',
          '3. L\'entitat tampoc no es responsabilitza del contingut dels llocs gestionats per tercers que s\'enllacin des de la pàgina web, així mateix aquests enllaços no implicaran l\'existència d\'algun tipus de relació per part de la Federació Aragonesa de Muntanyisme amb aquests tercers.'
        ]
      },
      propiedad:{
        titulo: 'Propietat Intel·lectual',
        texto: [
          '1. Tots els continguts d\'aquesta pàgina web entenent com a tals els textos, dibuixos, gràfics, fotografies, imatges, vídeos, música, codi, el disseny de la mateixa i qualsevol altra creació són propietat de Federació Aragonesa de Muntanyisme i PRAMES SA o dels seus titulars respectius mitjançant la corresponent llicència, autorització o cessió sobre els drets i estan protegits en funció de la legislació sobre la propietat intel·lectual i industrial.',
          '2. En cap cas no s\'entendrà que la posada a disposició del públic de la pàgina web constitueix renúncia, cessió o llicència dels drets que Federació Aragonesa de Muntanyisme i PRAMES, S.A. tenen sobre els continguts de la mateixa.',
          '3. Queda prohibit qualsevol ús dels continguts de la nostra pàgina web inclosa la modificació, còpia, reproducció, transmissió, etcètera sense la prèvia autorització per escrit de lentitat.'
        ]
      }
    },
    seguro: {
      titulo: 'Atenció',
      texto: [
        'alberguesyrefugios.com utilitza el pagament segur.',
        'Comprova que la teva targeta té el pagament segur activat abans de confirmar la reserva.'
      ]
    },
    btnPagar:'Confirmar dades',
    errores:{
      obligatorio: 'Aquest camp és obligatori',
      nombre:'Aquest camp és obligatori. Deu tenir 3 o més caràcters',
      apellidos:'Aquest camp és obligatori. Deu tenir 3 o més caràcters',
      dni:'Aquest camp és obligatori. El format ha de ser 12345678Z',
      fnac:'Aquest camp és obligatori i has de ser més gran.',
      direccion:'Aquest camp és obligatori. Deu tenir 3 o més caràcters',
      cp:'Aquest camp és obligatori. Deu tenir 5 caràcters',
      poblacion:'Necessitem saber aquesta dada.',
      provincia:'És necessària aquesta informació.',
      pais:'Necessitem saber això',
      correo:'Aquest camp és obligatori. Deu tenir format de correu electrònic.',
      confirmarCorreo:'Els correus deuen coincidir',
      tfno:'Aquest camp és obligatori. Deu tenir 9 caràcters.',
      club:''
    },
    login:{
      btnRegistrado:'iniciar sessió',
      btnNuevo: 'Vull reservar',
      saludo:'Hola ',
      info:'Aquestes dades es faran servir per fer la reserva. No es modifiquen a la teva fitxa.',
      btnSalir:'Sortir i cancel·lar la reserva',
      cerrarCancelar: 'Continuar amb la reserva',
      confirmarCancelar: 'Cancel·lar la reserva',
      textoCancelar: 'Voleu cancel·lar aquesta reserva?',
      modal:{
        titulo:'Identifiqueu-vos',
        olvido: 'Heu oblidat la contrasenya?',
        usuario:'Email',
        password:'Contrasenya',
        error: 'No hem pogut complir aquestes dades',
        btnCancelar:'Cancel·la',
        btnAceptar:'Acceptar'
      }
    },
    tituloExiste: 'Usuari registrat',
    existe: 'Ja existeix un usuari registrat amb aquest correu',
    covid: {
      pre:'Acepto les',
      anchor: 'noves condicions',
      post: 'pel COVID19'
    },
  },
  datosCalendario: {
    selected: 'Heu seleccionat:',
    night: 'Nit',
    nights: 'Nits',
    button: 'Botó',
    clearButton: 'Esborrar',
    submitButton: 'Enviar',
    'checkin-disabled': 'Check-in deshabilitat',
    'checkout-disabled': 'Check-out deshabilitat',
    'day-names-short': ['Dg', 'Dl', 'Dt', 'Dc', 'Dj', 'Dv', 'Ds'],
    'day-names': ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
    'month-names-short': ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Des'],
    'month-names': ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Disembre'],
    'error-more': 'L\'intervallo di date non deve avere più di 1 notte',
    'error-more-plural': 'L\' interval de dates no pot ser inferior a %d nits',
    'error-less': 'L\' interval de dates no pot ser inferior a 1 nit',
    'error-less-plural': 'El intervalo de fechas no puede ser inferior a %d noches',
    'info-more': 'Selecciona un interval de dates.',
    'info-more-plural': 'Selecciona un interval de dates superior a %d nits',
    'info-range': 'Selecciona un intervalo de fechas de %d a %d noches',
    'info-range-equal': 'Selecciona un interval de dates superior a %d nitss',
    'info-default': 'Selecciona un interval de dates',
    'aria-application': 'Calendari',
    'aria-selected-checkin': 'Data selezionata come check-in, %s',
    'aria-selected-checkout': 'Data selezionata come check-out, %s',
    'aria-selected': 'Data selezionata, %s',
    'aria-disabled': 'Non disponibile, %s',
    'aria-choose-checkin': 'Scegli %s come data del check-in',
    'aria-choose-checkout': 'Scegli %s come data del check-out',
    'aria-prev-month': 'Muovi indietro per visualizzare il mese precedente',
    'aria-next-month': 'Muovi in avanti per visualizzare il mese successivo',
    'aria-close-button': 'Chiudi il datepicker',
    'aria-clear-button': 'Cancella le date selezionate',
    'aria-submit-button': 'Invia il form',
    "status-opened": "Obert",
    "status-closed": "Tancat",
    "status-full": "Completo",
    "status-online": "Sense places en linia, truca per telèfon"
  },
});


// WEBPACK FOOTER //
// ./src/_locale/translations/ca.js